import { requestAuthenticationModal } from './requestAuthenticationModal';
import { TAuthenticationModalType } from '../../types/authenticationModal';
import { TThunkAction } from '../../types/redux';

export function requestAuthentication(type: TAuthenticationModalType): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, _context) => {
    // TODO заменить на globalEventsLog
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup(type);
    }

    dispatch(requestAuthenticationModal(type));
  };
}
